"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6547],{

/***/ 97871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ DotLoader; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../core-ui/dist/components/DotLoader/DotLoader.styles.js


const StyledDotLoader = styled_components_browser_esm/* default.div */.ZP.div `
    width: 15px;
    aspect-ratio: 1;
    border-radius: 50%;
    animation: loadingAnimation 1s infinite linear alternate;

    @keyframes loadingAnimation {
        0% {
            box-shadow: 20px 0 #000, -20px 0 #0002;
            background: #000;
        }
        33% {
            box-shadow: 20px 0 #000, -20px 0 #0002;
            background: #0002;
        }
        66% {
            box-shadow: 20px 0 #0002, -20px 0 #000;
            background: #0002;
        }
        100% {
            box-shadow: 20px 0 #0002, -20px 0 #000;
            background: #000;
        }
    }
`;


//# sourceMappingURL=DotLoader.styles.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/DotLoader/DotLoader.js




const DotLoader = (0,react.forwardRef)((props, ref) => {
    return (0,jsx_runtime.jsx)(StyledDotLoader, Object.assign({}, props));
});


//# sourceMappingURL=DotLoader.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/DotLoader/index.js


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 4759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Select_js__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Select_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64948);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 34055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ generateUrlParams; }
/* harmony export */ });
function generateUrlParams(obj) {
    let paramsString = "";
    const entries = Object.entries(obj);
    entries.forEach(([key, value], index) => {
        if (value !== undefined) {
            index === 0
                ? (paramsString += `${key}=${value}`)
                : (paramsString += `&${key}=${value}`);
        }
    });
    return paramsString;
}


//# sourceMappingURL=generateUrlParams.js.map


/***/ }),

/***/ 10478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ capitalize; }
/* harmony export */ });
function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}


//# sourceMappingURL=capitalize.js.map


/***/ }),

/***/ 65643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ AgentBadgeWithLabel; },
  "Z": function() { return /* binding */ badge_AgentBadge; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core-ui/dist/hooks/useToggleModalWithLocalState.js
var useToggleModalWithLocalState = __webpack_require__(8779);
// EXTERNAL MODULE: ../core-ui/dist/components/ModalOrBottomSheetWrapper/index.js
var ModalOrBottomSheetWrapper = __webpack_require__(9937);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/index.js
var Typography = __webpack_require__(71960);
// EXTERNAL MODULE: ../core-ui/dist/layout/Flex.js
var Flex = __webpack_require__(31013);
// EXTERNAL MODULE: ../core/dist/icons/Call_CTA_BLUE.svg
var Call_CTA_BLUE = __webpack_require__(27335);
// EXTERNAL MODULE: ../core-ui/dist/components/IconWrapper/IconWrapper.js + 1 modules
var IconWrapper = __webpack_require__(2709);
// EXTERNAL MODULE: ../core/dist/hooks/useCsDashboard.js
var useCsDashboard = __webpack_require__(68191);
// EXTERNAL MODULE: ./constants/adminOperation.ts
var adminOperation = __webpack_require__(40223);
;// CONCATENATED MODULE: ./components/admin/badge/AgentDetailsPopup.tsx









var AgentDetailsPopup = function(param) {
    var data = param.data, id = param.id, isOpen = param.isOpen, onToggle = param.onToggle;
    var ref;
    var phoneNumberShort = data === null || data === void 0 ? void 0 : (ref = data.phone_number) === null || ref === void 0 ? void 0 : ref.replace("+91", "");
    var checkPermission = (0,useCsDashboard/* useCsDashboard */.Z)().checkPermission;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrBottomSheetWrapper["default"], {
        titleText: "Agent Details",
        id: id,
        isOpen: isOpen,
        onToggle: onToggle,
        sheetBodyMinHeight: "20dvh",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
            flexDirection: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            children: "Name"
                        }),
                        " : ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            weight: "semibold",
                            children: data === null || data === void 0 ? void 0 : data.agent_name
                        })
                    ]
                }),
                checkPermission(adminOperation/* ADMIN_OPERATION.userPhoneNumberVisibilityUI */.F.userPhoneNumberVisibilityUI) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                    alignItems: "center",
                    gap: 8,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            children: "Phone Number"
                        }),
                        " :",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            weight: "semibold",
                            underline: true,
                            children: [
                                "+91-",
                                phoneNumberShort
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper/* default */.Z, {
                            onClick: function() {
                                window.open("tel:".concat(data === null || data === void 0 ? void 0 : data.phone_number), "_blank", "noopener noreferrer");
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Call_CTA_BLUE/* default */.Z, {})
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var badge_AgentDetailsPopup = (AgentDetailsPopup);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../core-ui/dist/components/Button/index.js
var Button = __webpack_require__(32450);
// EXTERNAL MODULE: ../core/dist/components/toast/toast.js + 6 modules
var toast = __webpack_require__(63118);
// EXTERNAL MODULE: ../core-ui/dist/components/Select/index.js
var Select = __webpack_require__(4759);
// EXTERNAL MODULE: ../core-ui/dist/components/DotLoader/index.js + 2 modules
var DotLoader = __webpack_require__(97871);
// EXTERNAL MODULE: ./components/admin/ticket-system/common/TextLabelAndValue/TextLabelAndValue.tsx
var TextLabelAndValue = __webpack_require__(9485);
// EXTERNAL MODULE: ../core-ui/dist/methods/string.js
var string = __webpack_require__(75905);
// EXTERNAL MODULE: ./methods/uiUtil.ts
var uiUtil = __webpack_require__(34695);
// EXTERNAL MODULE: ./methods/formatPhoneNumber.ts
var formatPhoneNumber = __webpack_require__(58729);
// EXTERNAL MODULE: ./hooks/useGetTicketsQuery.ts
var useGetTicketsQuery = __webpack_require__(36754);
// EXTERNAL MODULE: ../core/dist/hooks/useVahakQueryClient.js
var useVahakQueryClient = __webpack_require__(37528);
// EXTERNAL MODULE: ../core/dist/hooks/useVahakHttpClient.js
var hooks_useVahakHttpClient = __webpack_require__(36153);
// EXTERNAL MODULE: ../core/dist/_services/hooks/queryNames.js
var queryNames = __webpack_require__(49352);
// EXTERNAL MODULE: ../core/dist/_services/const.js
var _services_const = __webpack_require__(41634);
;// CONCATENATED MODULE: ./services/ticket-system/useLoadAssignv2.ts
//Hooks


// services

//Endpoints

var useLoadAssignv2 = function() {
    var method = function method(data) {
        return POST(_services_const/* default.LOAD_REASSIGN_V2 */.Z.LOAD_REASSIGN_V2, {
            load_id: data.loadId,
            ticket_type: data.ticketType,
            agent_company_id: data.agentCompanyId,
            remarks: data.remarks
        });
    };
    var POST = (0,hooks_useVahakHttpClient/* default */.Z)().POST;
    return (0,useVahakQueryClient/* useVahakMutationQuery */.M8)([
        queryNames/* QueryNames.dashboardUser.reassignLoad */._.dashboardUser.reassignLoad
    ], method);
};

;// CONCATENATED MODULE: ./services/ticket-system/useAssignTicket.ts




var useAssignTicket = function() {
    var POST = (0,hooks_useVahakHttpClient/* default */.Z)().POST;
    var method = function(params) {
        var payload = {
            company_id: params === null || params === void 0 ? void 0 : params.csCompanyId,
            ticket_id: params === null || params === void 0 ? void 0 : params.ticketId,
            override: params === null || params === void 0 ? void 0 : params.override
        };
        return POST(_services_const/* default.ASSIGN_TICKET */.Z.ASSIGN_TICKET, payload);
    };
    return (0,useVahakQueryClient/* useVahakMutationQuery */.M8)([
        queryNames/* QueryNames.ticketSystem.assignTicket */._.ticketSystem.assignTicket
    ], method);
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../core-ui/dist/methods/generateUrlParams.js
var methods_generateUrlParams = __webpack_require__(34055);
// EXTERNAL MODULE: ../core/dist/hooks/index.js + 6 modules
var hooks = __webpack_require__(37113);
// EXTERNAL MODULE: ../core/dist/constants/index.js + 4 modules
var constants = __webpack_require__(94204);
;// CONCATENATED MODULE: ./services/admin-user/useGetCSUsers.ts




// services


// types




var HIDDEN_USER_LIST = constants/* USER_GROUP.SUPER_USERS */.tfp.SUPER_USERS;
var mapParamsToPayloadToGetCsUserData = function(params) {
    var payload = {
        page: params === null || params === void 0 ? void 0 : params.page,
        role_id: params === null || params === void 0 ? void 0 : params.roleType,
        p_n: params === null || params === void 0 ? void 0 : params.phoneNumber,
        l: params === null || params === void 0 ? void 0 : params.limit,
        manager_user_id: params === null || params === void 0 ? void 0 : params.managerUserId
    };
    return payload;
};
var filterHiddenCsUser = function(list, byPass) {
    return list === null || list === void 0 ? void 0 : list.filter(function(param) {
        var role_ids = param.role_ids;
        return role_ids && byPass ? true : !HIDDEN_USER_LIST.find(function(userId) {
            return role_ids === null || role_ids === void 0 ? void 0 : role_ids.includes(userId);
        });
    });
};
var useGetCSUsers = function(params, options) {
    var getCSUsers = function getCSUsers(param) {
        var _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 1 : _pageParam;
        var payload = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, mapParamsToPayloadToGetCsUserData(params)), {
            page: pageParam
        });
        var urlString = (0,methods_generateUrlParams/* generateUrlParams */.h)(payload);
        return GET("".concat(_services_const/* default.GET_CS_USERS */.Z.GET_CS_USERS).concat(urlString));
    };
    var roleType = params.roleType, phoneNumber = params.phoneNumber, limit = params.limit, managerUserId = params.managerUserId;
    var GET = (0,hooks_useVahakHttpClient/* default */.Z)().GET;
    var isDeveloper = (0,hooks/* useCsDashboard */.Z0)().isDeveloper;
    return (0,useVahakQueryClient/* useVahakInfiniteQuery */.xX)([
        queryNames/* QueryNames.dashboardUser.getCSUsers */._.dashboardUser.getCSUsers,
        roleType,
        phoneNumber,
        managerUserId
    ], getCSUsers, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        getNextPageParam: function(lastPage, allPages) {
            var ref, ref1, ref2;
            if (((ref = lastPage.data) === null || ref === void 0 ? void 0 : ref.page_number) < ((ref1 = lastPage.data) === null || ref1 === void 0 ? void 0 : ref1.total_pages)) return ((ref2 = lastPage.data) === null || ref2 === void 0 ? void 0 : ref2.page_number) + 1;
            return undefined;
        }
    }, options), {
        onSuccess: function(data) {
            var aggregatedData = [];
            data.pages.forEach(function(data) {
                var ref;
                var ref1;
                aggregatedData = (0,_to_consumable_array/* default */.Z)(aggregatedData).concat((0,_to_consumable_array/* default */.Z)((ref1 = data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.details) !== null && ref1 !== void 0 ? ref1 : []));
            });
            options.onSuccess(filterHiddenCsUser(aggregatedData, !!isDeveloper));
        }
    }));
};
var useGetCSUsersMutation = function() {
    var getCSUsers = function getCSUsers(params) {
        var payload = mapParamsToPayloadToGetCsUserData(params);
        var urlString = (0,methods_generateUrlParams/* generateUrlParams */.h)(payload);
        return GET("".concat(_services_const/* default.GET_CS_USERS */.Z.GET_CS_USERS).concat(urlString));
    };
    var GET = (0,hooks_useVahakHttpClient/* default */.Z)().GET;
    return (0,useVahakQueryClient/* useVahakMutationQuery */.M8)([
        queryNames/* QueryNames.dashboardUser.getCSUsers */._.dashboardUser.getCSUsers
    ], getCSUsers);
};
var useGetCSUserDetails = function(params, options) {
    var getList = function getList(param) {
        var _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 1 : _pageParam;
        var payload = {
            user_id: userId,
            page: pageParam
        };
        var urlString = generateUrlParams(payload);
        return GET("".concat(API.GET_CS_USER_DETAILS).concat(urlString));
    };
    var GET = useVahakHttpClient().GET;
    var userId = params.userId;
    return useVahakQuery([
        QueryNames.dashboardUser.getCSUserDetails,
        params
    ], getList, _object_spread_props(_object_spread({}, options), {
        select: function(data) {
            return data.data;
        }
    }));
};

// EXTERNAL MODULE: ../core-ui/dist/components/Search/index.js
var Search = __webpack_require__(63112);
// EXTERNAL MODULE: ../core/dist/constants/api.js
var api = __webpack_require__(24966);
// EXTERNAL MODULE: ../core-ui/dist/components/Chip/index.js
var Chip = __webpack_require__(93834);
;// CONCATENATED MODULE: ./components/admin/dashboard-user/SearchCsUserOption.tsx














var CsAttendanceAction;
(function(CsAttendanceAction) {
    CsAttendanceAction[CsAttendanceAction["LOG_OUT"] = 1] = "LOG_OUT";
    CsAttendanceAction[CsAttendanceAction["LOG_IN"] = 2] = "LOG_IN";
    CsAttendanceAction[CsAttendanceAction["BREAK"] = 3] = "BREAK";
})(CsAttendanceAction || (CsAttendanceAction = {}));
var SearchCsUserOption = function(param) {
    var searchProps = param.searchProps, wrapperClassName = param.wrapperClassName, inlineStyle = param.inlineStyle, filter = param.filter, onSelect = param.onSelect, selectedUser = param.selectedUser;
    var ref;
    var ref1 = (0,react.useState)(""), phoneNumberText = ref1[0], setPhoneNumberText = ref1[1];
    var isDeveloper = (0,hooks/* useCsDashboard */.Z0)().isDeveloper;
    var getUserLabel = function(user) {
        var phone = user.phone_number ? "+91-".concat((0,formatPhoneNumber/* formatPhoneNumber */.u)(user.phone_number.replace("+91", ""))) : "";
        return [
            user.name,
            isDeveloper && phone ? "(".concat(phone, ")") : ""
        ].filter(Boolean).join(" ");
    };
    var selectedOption = selectedUser ? (0,uiUtil/* generateSelectOption */.Ow)(getUserLabel(selectedUser), selectedUser) : undefined;
    var ref2 = useGetCSUsersMutation(), getCsUserList = ref2.mutateAsync;
    var getCsUserListOption = function() {
        var list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        return list.map(function(user) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,uiUtil/* generateSelectOption */.Ow)(getUserLabel(user), user)), {
                leftNode: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                    color: (user === null || user === void 0 ? void 0 : user.current_attendance_status) === CsAttendanceAction.LOG_IN ? "green" : "grey",
                    filled: true,
                    padded: false,
                    radius: 32,
                    size: "dot",
                    dotSize: 2
                })
            });
        });
    };
    var ref3 = useGetCSUsers((0,src_object_spread/* default */.Z)({}, filter), (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, api/* NoSuccessErrorHandler */.jt), {
        refetchOnWindowFocus: false,
        cacheTime: Infinity,
        staleTime: Infinity
    })), isFetching = ref3.isFetching, hasNextPage = ref3.hasNextPage, fetchNextPage = ref3.fetchNextPage, data = ref3.data;
    var users = getCsUserListOption(data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref.flatMap(function(p) {
        var ref;
        return p === null || p === void 0 ? void 0 : (ref = p.data) === null || ref === void 0 ? void 0 : ref.details;
    }));
    var onChangeSelectInput = function(newValue) {
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(newValue === null || newValue === void 0 ? void 0 : newValue.value);
    };
    var getPhoneNumberFroText = function(str) {
        return (0,string/* stringOperations */.$M)(str, [
            "removeNonNumeric",
            "trim",
            "truncate:10"
        ]);
    };
    var onChangeSearchInput = function(str) {
        setPhoneNumberText(getPhoneNumberFroText(str));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: wrapperClassName,
        style: inlineStyle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, (0,src_object_spread/* default */.Z)({
            loadOptions: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input, cb) {
                    var phoneNumber, ref, data, ref1;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                phoneNumber = getPhoneNumberFroText(input);
                                if (!((phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.length) === 10)) {
                                    _ctx.next = 10;
                                    break;
                                }
                                ;
                                _ctx.next = 5;
                                return getCsUserList({
                                    phoneNumber: phoneNumber
                                });
                            case 5:
                                data = _ctx.sent;
                                ;
                                cb(getCsUserListOption(filterHiddenCsUser((ref1 = data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.details) !== null && ref1 !== void 0 ? ref1 : [], !!isDeveloper)));
                                _ctx.next = 11;
                                break;
                            case 10:
                                {
                                    cb([]);
                                }
                            case 11:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function(input, cb) {
                    return _ref.apply(this, arguments);
                };
            }(),
            isLoading: isFetching,
            inputValue: phoneNumberText,
            onInputChange: onChangeSearchInput,
            value: selectedOption,
            defaultOptions: users,
            onChange: onChangeSelectInput,
            option: [],
            placeholder: "Select User",
            onMenuScrollToBottom: function() {
                hasNextPage && fetchNextPage();
            },
            noOptionText: "No Users",
            isClearable: true,
            required: true
        }, searchProps))
    });
};
/* harmony default export */ var dashboard_user_SearchCsUserOption = (SearchCsUserOption);

// EXTERNAL MODULE: ../core-ui/dist/methods/time.js
var time = __webpack_require__(72);
// EXTERNAL MODULE: ../core-ui/dist/constants/symbol.js
var symbol = __webpack_require__(40423);
// EXTERNAL MODULE: ../core-ui/dist/methods/index.js + 3 modules
var methods = __webpack_require__(38920);
// EXTERNAL MODULE: ./components/admin/ticket-system-helper/constants.ts
var ticket_system_helper_constants = __webpack_require__(60280);
;// CONCATENATED MODULE: ./components/admin/badge/AssignedCsPopup.tsx














// Methods













var generateCsUserOption = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(str, callback, csSearchMethod) {
        var phoneNumber, ref, data, ref1;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    phoneNumber = (0,string/* stringOperations */.$M)(str, [
                        "removeNonNumeric",
                        "trim",
                        "truncate:10"
                    ]);
                    phoneNumber = phoneNumber.length === 10 ? phoneNumber : undefined;
                    if (!(phoneNumber && csSearchMethod)) {
                        _ctx.next = 11;
                        break;
                    }
                    ;
                    _ctx.next = 6;
                    return csSearchMethod({
                        phoneNumber: phoneNumber
                    });
                case 6:
                    data = _ctx.sent;
                    ;
                    callback(getCsUserListOption((ref1 = data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.details) !== null && ref1 !== void 0 ? ref1 : []));
                    _ctx.next = 12;
                    break;
                case 11:
                    {
                        callback([]);
                    }
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function generateCsUserOption(str, callback, csSearchMethod) {
        return _ref.apply(this, arguments);
    };
}();
var getCsUserListOption = function(list) {
    return list.map(function(user) {
        return (0,uiUtil/* generateSelectOption */.Ow)([
            user.name,
            "(".concat(user.phone_number, ")")
        ].join(" "), user, user.user_id);
    });
};
var getLoadAssignmentTimeStr = function(data) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "long", requireAssignee = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    return (!requireAssignee || !!(data === null || data === void 0 ? void 0 : data.assigned_to)) && !!(data === null || data === void 0 ? void 0 : data.assigned_at) && (0,methods/* getJoinedStringFromArray */.D$)([
        (0,time/* formatDate */.p6)(data.assigned_at, type === "long" ? "hh:mm a -  DD/MM" : "h:mm a -  DD/MM"),
        (0,time/* getRelativeTimeString */.qF)(new Date(data.assigned_at))
    ], " ".concat(symbol/* DotSymbol */.u, " "));
};
var AssignmentDropdownOption = [
    "Generated Lead",
    "Language Barrier",
    "Unavailability"
].map(function(v) {
    return (0,uiUtil/* generateSelectOption */.Ow)(v, v, v);
});
var _obj;
var ticketTypeToAgentRoleMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, ticket_system_helper_constants/* LoadTicketType.VERIFICATION */.gS.VERIFICATION, constants/* UserType.VERIFICATION_EXECUTIVE */.FWD.VERIFICATION_EXECUTIVE), (0,_define_property/* default */.Z)(_obj, ticket_system_helper_constants/* LoadTicketType.FULFILLMENT */.gS.FULFILLMENT, constants/* UserType.FULLFILMENT_EXECUTIVE */.FWD.FULLFILMENT_EXECUTIVE), (0,_define_property/* default */.Z)(_obj, ticket_system_helper_constants/* LoadTicketType.PP_PLACEMENT */.gS.PP_PLACEMENT, constants/* UserType.PP_PLACEMENT */.FWD.PP_PLACEMENT), (0,_define_property/* default */.Z)(_obj, ticket_system_helper_constants/* LoadTicketType.PP_LOADING */.gS.PP_LOADING, constants/* UserType.PP_LOADING */.FWD.PP_LOADING), (0,_define_property/* default */.Z)(_obj, ticket_system_helper_constants/* LoadTicketType.PP_UNLOADING */.gS.PP_UNLOADING, constants/* UserType.PP_UNLOADING */.FWD.PP_UNLOADING), (0,_define_property/* default */.Z)(_obj, ticket_system_helper_constants/* TicketType.IN_TRANSIT_CALLBACK */.zK.IN_TRANSIT_CALLBACK, constants/* UserType.IN_TRANSIT_SUPPORT */.FWD.IN_TRANSIT_SUPPORT), _obj);
var AssignedCsPopup = function(param) {
    var data = param.data, payload = param.payload, id = param.id, isOpen = param.isOpen, onToggle = param.onToggle, onSuccess = param.onSuccess;
    var ref, ref1, ref2, ref3;
    var isDeveloper = (0,hooks/* useCsDashboard */.Z0)().isDeveloper;
    var ref4 = useLoadAssignv2(), reassignLoadV2 = ref4.mutateAsync;
    var ref5 = useAssignTicket(), assignTicket = ref5.mutateAsync;
    var ref6 = (0,react.useState)(), selectedUser = ref6[0], setSelectedUser = ref6[1];
    var ref7 = (0,react.useState)(), remarks = ref7[0], setRemarks = ref7[1];
    var ref8 = (0,react.useState)(), fetchedTicket = ref8[0], setFetchedTicket = ref8[1];
    var passedTicket = payload === null || payload === void 0 ? void 0 : payload.ticket;
    var shouldFetchTicket = !passedTicket && !!(payload === null || payload === void 0 ? void 0 : payload.loadId) && !!(payload === null || payload === void 0 ? void 0 : payload.ticketType);
    var tktData = passedTicket !== null && passedTicket !== void 0 ? passedTicket : fetchedTicket;
    var onContinue = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (!(!(selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.company_id) || !(tktData === null || tktData === void 0 ? void 0 : tktData.id))) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        if (!passedTicket) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 6;
                        return assignTicket({
                            csCompanyId: selectedUser.company_id,
                            ticketId: tktData.id,
                            override: !!(data === null || data === void 0 ? void 0 : data.assigned_to)
                        });
                    case 6:
                        _ctx.next = 14;
                        break;
                    case 8:
                        if (!((payload === null || payload === void 0 ? void 0 : payload.loadId) && payload.ticketType)) {
                            _ctx.next = 13;
                            break;
                        }
                        _ctx.next = 11;
                        return reassignLoadV2({
                            loadId: payload.loadId,
                            agentCompanyId: selectedUser.company_id,
                            ticketType: payload.ticketType,
                            remarks: remarks === null || remarks === void 0 ? void 0 : remarks.value
                        });
                    case 11:
                        _ctx.next = 14;
                        break;
                    case 13:
                        return _ctx.abrupt("return");
                    case 14:
                        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                        onToggle === null || onToggle === void 0 ? void 0 : onToggle(false);
                        _ctx.next = 21;
                        break;
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](0);
                        toast/* toast.error */.A.error(_ctx.t0.message);
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    18
                ]
            ]);
        }));
        return function onContinue() {
            return _ref.apply(this, arguments);
        };
    }();
    var ticketQueryResponse = (0,useGetTicketsQuery/* useGetTicketsQuery */.N)({
        ticket_type: payload === null || payload === void 0 ? void 0 : payload.ticketType,
        referenceId: [
            payload === null || payload === void 0 ? void 0 : payload.loadId
        ],
        limit: 1
    }, {
        onSuccess: function(data) {
            var result = data === null || data === void 0 ? void 0 : data.at(0);
            setFetchedTicket(result);
            if (!(result === null || result === void 0 ? void 0 : result.id)) {
                toast/* toast.dismiss */.A.dismiss();
                toast/* toast.error */.A.error("Re-assignment not possible");
                onToggle === null || onToggle === void 0 ? void 0 : onToggle(false);
            }
        },
        onError: function(err) {
            toast/* toast.error */.A.error(err.message);
        },
        enabled: shouldFetchTicket,
        retry: false
    });
    var assignedName = (data === null || data === void 0 ? void 0 : data.name) || (tktData === null || tktData === void 0 ? void 0 : (ref = tktData.assigned_to_details) === null || ref === void 0 ? void 0 : ref.company_name);
    var assignedPhone = isDeveloper ? data === null || data === void 0 ? void 0 : data.phone_number : undefined;
    var formattedPhone = assignedPhone ? "+91-".concat((0,formatPhoneNumber/* formatPhoneNumber */.u)(assignedPhone.replace("+91", ""))) : "";
    var dataToShow = {
        Type: ticket_system_helper_constants/* LoadTicketType */.gS[payload === null || payload === void 0 ? void 0 : payload.ticketType] || "",
        "Currently Assigned To": assignedName ? [
            assignedName,
            formattedPhone ? "(".concat(formattedPhone, ")") : ""
        ].filter(Boolean).join(" ") : "None",
        "Update By": tktData === null || tktData === void 0 ? void 0 : (ref1 = tktData.updated_by_details) === null || ref1 === void 0 ? void 0 : ref1.company_name,
        "Assignemnt Type": tktData === null || tktData === void 0 ? void 0 : (ref2 = tktData.meta_data) === null || ref2 === void 0 ? void 0 : ref2.assignment_source,
        Remarks: (tktData === null || tktData === void 0 ? void 0 : (ref3 = tktData.meta_data) === null || ref3 === void 0 ? void 0 : ref3.assignment_reason) || "N/A"
    };
    var roleType = ticketTypeToAgentRoleMap[payload === null || payload === void 0 ? void 0 : payload.ticketType];
    var canContinue = !!(selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.user_id) && !!(remarks === null || remarks === void 0 ? void 0 : remarks.value.trim()) && !!(tktData === null || tktData === void 0 ? void 0 : tktData.id) && [
        ticket_system_helper_constants/* TicketStatusMap.Unverified */.Rt.Unverified,
        ticket_system_helper_constants/* TicketStatusMap.Resolving */.Rt.Resolving
    ].includes(tktData === null || tktData === void 0 ? void 0 : tktData.status);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrBottomSheetWrapper["default"], {
        titleText: "Assigned To",
        id: id,
        isOpen: isOpen && (!!passedTicket || (ticketQueryResponse === null || ticketQueryResponse === void 0 ? void 0 : ticketQueryResponse.isFetched)),
        onToggle: onToggle,
        sheetBodyMinHeight: "20dvh",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
            flexDirection: "column",
            gap: 32,
            children: [
                !!(data === null || data === void 0 ? void 0 : data.assigned_to) && !!(data === null || data === void 0 ? void 0 : data.assigned_at) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            children: "Assigned At : "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            children: getLoadAssignmentTimeStr(data)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    size: "md",
                    children: Object.entries(dataToShow).map(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], val = _param[1];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLabelAndValue/* default */.Z, {
                            label: key,
                            value: shouldFetchTicket && (ticketQueryResponse === null || ticketQueryResponse === void 0 ? void 0 : ticketQueryResponse.isFetching) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DotLoader["default"], {}) : val
                        });
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* VerticalFlex */.vs, {
                    style: {
                        width: 400
                    },
                    gap: 20,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dashboard_user_SearchCsUserOption, {
                            filter: {
                                limit: 10,
                                roleType: roleType
                            },
                            onSelect: function(assignedToCsUserData) {
                                setSelectedUser(assignedToCsUserData);
                            },
                            selectedUser: selectedUser,
                            searchProps: {
                                placeholder: "Search using Phone (8295 XXX XXX)",
                                label: "Select new assignee"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                            option: AssignmentDropdownOption,
                            value: remarks,
                            onChange: function(v) {
                                return setRemarks(v);
                            },
                            isSearchable: true,
                            headingLabel: "Remarks",
                            placeholder: ""
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.ZP, {
                    justifyContent: "flex-end",
                    style: {
                        marginTop: 20
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: onContinue,
                        disabled: !canContinue,
                        children: "Update"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var badge_AssignedCsPopup = (AssignedCsPopup);

// EXTERNAL MODULE: ./components/quick-action-popup/QuickActionPopup.tsx
var QuickActionPopup = __webpack_require__(37372);
// EXTERNAL MODULE: ../core/dist/icons/info_grey.svg
var info_grey = __webpack_require__(23045);
// EXTERNAL MODULE: ../core-ui/dist/components/TextCTA/index.js
var TextCTA = __webpack_require__(14342);
;// CONCATENATED MODULE: ./components/admin/badge/UnassigmentInfo.tsx








var UnassigmentInfo = function(param) {
    var isOpen = param.isOpen, onToggle = param.onToggle, data = param.data;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !!(data === null || data === void 0 ? void 0 : (ref = data.unassignment_data) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextCTA/* default */.Z, {
                onClick: onToggle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(info_grey/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickActionPopup/* default */.Z, {
                titleText: "Unassignment Reasons",
                isOpen: isOpen,
                onToggle: onToggle,
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* VerticalFlex */.vs, {
                    children: data === null || data === void 0 ? void 0 : (ref1 = data.unassignment_data) === null || ref1 === void 0 ? void 0 : ref1.map(function(dt) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLabelAndValue/* default */.Z, {
                            label: (0,methods/* formatDate */.p6)((0,methods/* toValidDate */.w0)(1000 * (dt === null || dt === void 0 ? void 0 : dt.attempted_at)), "YYYY-MM-DD hh:mm a"),
                            value: dt === null || dt === void 0 ? void 0 : dt.unassignment_reasons
                        });
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var badge_UnassigmentInfo = (UnassigmentInfo);

;// CONCATENATED MODULE: ./components/admin/badge/AgentBadge.tsx












var AgentBadge = function(props) {
    var type = props.type, data = props.data;
    var ref = (0,useToggleModalWithLocalState/* useToggleModalWithLocalState */.A)(false), isModalOpen = ref.isModalOpen, toggleModal = ref.toggleModal;
    var autoAssigmentInfoPopup = (0,useToggleModalWithLocalState/* useToggleModalWithLocalState */.A)(false);
    var isTsoV2 = (0,hooks/* useCsDashboard */.Z0)().isTsoV2;
    switch(type){
        case "cs":
            {
                var onClick = props.allowAssignment ? toggleModal : undefined;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                    gap: 4,
                    alignItems: "center",
                    style: {},
                    children: [
                        props === null || props === void 0 ? void 0 : props.label,
                        (data === null || data === void 0 ? void 0 : data.name) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                            color: "blue",
                            size: "auto",
                            outlined: true,
                            radius: 12,
                            onClick: onClick,
                            children: data.name
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                            color: "grey",
                            size: "auto",
                            outlined: true,
                            radius: 12,
                            onClick: onClick,
                            children: "Un-assigned"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_UnassigmentInfo, {
                            data: props === null || props === void 0 ? void 0 : props.autoAssignmentInfo,
                            isOpen: autoAssigmentInfoPopup === null || autoAssigmentInfoPopup === void 0 ? void 0 : autoAssigmentInfoPopup.isModalOpen,
                            onToggle: autoAssigmentInfoPopup === null || autoAssigmentInfoPopup === void 0 ? void 0 : autoAssigmentInfoPopup.toggleModal
                        }),
                        isModalOpen && props.onSuccess && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_AssignedCsPopup, {
                            data: data,
                            isOpen: isModalOpen,
                            onToggle: toggleModal,
                            payload: props.payload,
                            onSuccess: props.onSuccess
                        })
                    ]
                });
            }
        case "tso":
            {
                if (isTsoV2) {
                    return null;
                }
                return (data === null || data === void 0 ? void 0 : data.agent_name) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                            color: "green",
                            size: "auto",
                            outlined: true,
                            radius: 12,
                            onClick: toggleModal,
                            children: data === null || data === void 0 ? void 0 : data.agent_name
                        }),
                        isModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_AgentDetailsPopup, {
                            data: data,
                            isOpen: isModalOpen,
                            onToggle: toggleModal
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                    color: "grey",
                    size: "auto",
                    outlined: true,
                    radius: 12,
                    children: "Un-tagged"
                });
            }
    }
};
/* harmony default export */ var badge_AgentBadge = (AgentBadge);
var AgentBadgeWithLabel = function(props) {
    var label = props.label, restProps = (0,_object_without_properties/* default */.Z)(props, [
        "label"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
            size: "s",
            children: [
                label ? label + ": " : "",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AgentBadge, (0,src_object_spread/* default */.Z)({}, restProps))
            ]
        })
    });
};


/***/ }),

/***/ 28343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ ServiceTypeOptions; },
/* harmony export */   "y": function() { return /* binding */ getServiceTypeInfoByName; }
/* harmony export */ });
/* harmony import */ var _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94204);

var ServiceTypeOptions = [
    {
        label: "Truck Owner/Driver",
        signUpLabel: "I am a Lorry Owner",
        shortLabel: "Trucker",
        value: _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__/* .CompanyServiceType.FLEET_OWNER */ .AAU.FLEET_OWNER,
        description: "I have truck(s) and I am looking for loads",
        signUpDescription: "I am searching for load near me",
        icon: "/lorry_owner_icon.svg",
        lookingForLabel: "Find Loads",
        lookingForAlternative: "Find Shippers",
        lookingForIcon: "find-load.svg",
        membershipCategoryIconName: "/Membership_trucker.svg",
        membershipCategoryActiveIconName: "/Membership_trucker_white.svg",
        membershipPlanOrderKey: 2,
        membershipServiceTypeId: _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceTypeId.TRUCKER */ .VPA.TRUCKER
    },
    {
        label: "Shipper",
        signUpLabel: "I am a Shipper",
        shortLabel: "Shipper",
        value: _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__/* .CompanyServiceType.SHIPPER */ .AAU.SHIPPER,
        description: "I have loads and I am searching for trucks",
        signUpDescription: "I am searching for a lorry",
        icon: "/load_owner_icon.svg",
        lookingForLabel: "Find Lorries",
        lookingForAlternative: "Find Truck owners",
        lookingForIcon: "find-lorry.svg",
        membershipCategoryIconName: "/Membership_shipper.svg",
        membershipCategoryActiveIconName: "/Membership_shipper_white.svg",
        membershipPlanOrderKey: 1,
        membershipServiceTypeId: _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceTypeId.SHIPPER */ .VPA.SHIPPER
    },
    {
        label: "Transporter",
        signUpLabel: "I am a Transporter / Broker",
        shortLabel: "Transporter",
        value: _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__/* .CompanyServiceType.TRANSPORT_CONTRACTOR */ .AAU.TRANSPORT_CONTRACTOR,
        description: "I am searching for both loads and lorries",
        signUpDescription: "I am searching for  load and lorry",
        icon: "/transporter_icon.svg",
        lookingForLabel: "Find Loads & Lorries",
        lookingForAlternative: "Find Both",
        lookingForIcon: "find-load-lorry.svg",
        membershipCategoryIconName: "/Membership_transporter.svg",
        membershipCategoryActiveIconName: "/Membership_transporter_white.svg",
        membershipPlanOrderKey: 3,
        membershipServiceTypeId: _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceTypeId.TRANSPORTER */ .VPA.TRANSPORTER
    }
];
var getServiceTypeInfoByName = function(type) {
    return ServiceTypeOptions.find(function(v) {
        return v.value === type;
    });
};


/***/ }),

/***/ 36754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useGetTicketsQuery; }
/* harmony export */ });
/* unused harmony export useGetTicketsMutationQuery */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50930);
/* harmony import */ var _vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37528);
/* harmony import */ var _vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36153);
/* harmony import */ var _vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41634);
/* harmony import */ var _vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49352);
/* harmony import */ var _components_admin_ticket_system_helper_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60280);
/* harmony import */ var _vahak_core_dist_methods_getUniqueArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88020);









var getAdditionalPreloads = function(ticketTypes) {
    var basic = [
        "company_details",
        "updated_by_details"
    ];
    if (!ticketTypes.length) {
        return basic;
    }
    return (0,_vahak_core_dist_methods_getUniqueArray__WEBPACK_IMPORTED_MODULE_5__/* .getUniqueArray */ .c)(ticketTypes.flatMap(function(ticketType) {
        switch(ticketType){
            case _components_admin_ticket_system_helper_constants__WEBPACK_IMPORTED_MODULE_4__/* .TicketType.REFUND_REQUEST */ .zK.REFUND_REQUEST:
                {
                    return [
                        "requested_by_details",
                        "requested_to_details",
                        "updated_by_details"
                    ];
                }
            case _components_admin_ticket_system_helper_constants__WEBPACK_IMPORTED_MODULE_4__/* .TicketType.VAS_LEADS_GPS */ .zK.VAS_LEADS_GPS:
            case _components_admin_ticket_system_helper_constants__WEBPACK_IMPORTED_MODULE_4__/* .TicketType.VAS_LEADS_CARGO */ .zK.VAS_LEADS_CARGO:
            case _components_admin_ticket_system_helper_constants__WEBPACK_IMPORTED_MODULE_4__/* .TicketType.COMPANY_REGISTRATION */ .zK.COMPANY_REGISTRATION:
            case _components_admin_ticket_system_helper_constants__WEBPACK_IMPORTED_MODULE_4__/* .TicketType.ADS_LEADS */ .zK.ADS_LEADS:
            case _components_admin_ticket_system_helper_constants__WEBPACK_IMPORTED_MODULE_4__/* .TicketType.TSO_LEAD_FORM */ .zK.TSO_LEAD_FORM:
                {
                    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(basic).concat([
                        "agent_details"
                    ]);
                }
            case _components_admin_ticket_system_helper_constants__WEBPACK_IMPORTED_MODULE_4__/* .TicketType.BID_CANCELLATION */ .zK.BID_CANCELLATION:
                {
                    return [
                        "cancel_tap_n_go",
                        "updated_by_details"
                    ];
                }
            case _components_admin_ticket_system_helper_constants__WEBPACK_IMPORTED_MODULE_4__/* .TicketType.IN_TRANSIT_CALLBACK */ .zK.IN_TRANSIT_CALLBACK:
            case _components_admin_ticket_system_helper_constants__WEBPACK_IMPORTED_MODULE_4__/* .TicketType.CALL_ME_BACK */ .zK.CALL_ME_BACK:
                {
                    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(basic).concat([
                        "assigned_to_details"
                    ]);
                }
            default:
                {
                    return basic;
                }
        }
    }));
};
var mapPayload = function(params) {
    var ref;
    var ticket_type = params.ticket_type, status = params.status, phone_number = params.phone_number, subscription_plan_id = params.subscription_plan_id, cityId = params.cityId, limit = params.limit, endDate = params.endDate, startDate = params.startDate, referenceId = params.referenceId, ticketTypesList = params.ticketTypesList;
    var ticketTypes = (0,_vahak_core_dist_methods_getUniqueArray__WEBPACK_IMPORTED_MODULE_5__/* .getUniqueArray */ .c)([
        ticket_type
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(ticketTypesList !== null && ticketTypesList !== void 0 ? ticketTypesList : [])).filter(function(type) {
        return Number.isInteger(type);
    }));
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        ticket_type: ticket_type,
        status: status,
        limit: limit,
        subscription_plan_id: subscription_plan_id,
        city_id: cityId,
        phone_number: phone_number,
        preloads: getAdditionalPreloads(ticketTypes),
        reference_id: referenceId,
        reference_type: params === null || params === void 0 ? void 0 : params.referenceType
    }, (startDate || endDate) && {
        created_at: {
            min: startDate,
            max: endDate
        }
    }), {
        source_of_registration: params === null || params === void 0 ? void 0 : params.source,
        service_type: params === null || params === void 0 ? void 0 : params.serviceType,
        company_id: params === null || params === void 0 ? void 0 : params.companyId,
        city_ids: params === null || params === void 0 ? void 0 : params.cityIds,
        state_ids: params === null || params === void 0 ? void 0 : params.stateIds,
        assigned_to: params === null || params === void 0 ? void 0 : params.ticketAssignedTo,
        lorry_type: (params === null || params === void 0 ? void 0 : params.lorryTypeIds) || (Number.isInteger(params === null || params === void 0 ? void 0 : params.lorryTypeId) ? [
            params === null || params === void 0 ? void 0 : params.lorryTypeId
        ] : undefined),
        description: params === null || params === void 0 ? void 0 : params.description,
        disposition_id: params === null || params === void 0 ? void 0 : params.dispositionId,
        ticket_types: (ticketTypesList === null || ticketTypesList === void 0 ? void 0 : ticketTypesList.length) ? ticketTypes : undefined,
        status_ids: (params === null || params === void 0 ? void 0 : (ref = params.status_ids) === null || ref === void 0 ? void 0 : ref.length) ? params === null || params === void 0 ? void 0 : params.status_ids : undefined
    });
};
var useGetTicketsQuery = function(params, options) {
    var getTickets = function getTickets(param) {
        var _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 1 : _pageParam;
        var payload = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            page_number: pageParam
        }, mapPayload(params));
        return POST(_vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_2__/* ["default"].GET_TICKETS */ .Z.GET_TICKETS, payload);
    };
    var POST = (0,_vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().POST;
    return (0,_vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_0__/* .useVahakInfiniteQuery */ .xX)([
        _vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_3__/* .QueryNames.ticketSystem.getTickets */ ._.ticketSystem.getTickets,
        params
    ], getTickets, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        getNextPageParam: function(lastPage, allPages) {
            if (lastPage.data.page_number < lastPage.data.total_pages) return lastPage.data.page_number + 1;
            return undefined;
        }
    }, options), {
        onSuccess: function(data) {
            var aggregatedData = [];
            data.pages.forEach(function(data) {
                aggregatedData = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(aggregatedData).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(data.data.tickets_list));
            });
            options.onSuccess(aggregatedData);
        }
    }));
};
var useGetTicketsMutationQuery = function() {
    var POST = useVahakHttpClient().POST;
    var method = function(params) {
        var payload = mapPayload(params);
        return POST(API.GET_TICKETS, payload);
    };
    return useVahakMutationQuery([
        QueryNames.ticketSystem.getTickets
    ], method);
};


/***/ }),

/***/ 58729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ formatPhoneNumber; }
/* harmony export */ });
var formatPhoneNumber = function(str) {
    var result = str;
    result = result.replace(/[^0-9]+/g, ""); // allow only number
    result = result.replace(/[^0-9]/gi, ""); // removes all the spaces and other characters other than number
    result = result.slice(0, 10);
    return result;
};


/***/ })

}]);